import type { Ref } from 'vue';
import type { ColorMode } from '@hypercodestudio/basler-components';

import type { LOCALE_CODE } from '~~/lib/ContentfulService';

export default defineNuxtPlugin(() => {
  const { $requestedLocale } = useNuxtApp();
  const url = useRequestURL();

  const colorMode: Ref<ColorMode | undefined> = useState<ColorMode | undefined>(
    'colorMode',
    () =>
      url.pathname.startsWith(`/${$requestedLocale.value}/shop`)
        ? 'light'
        : undefined
  );
  /**
   * Should contain a slug for every available page in the given language code.
   */
  const localeSlugMap = useState<Partial<Record<LOCALE_CODE, string>>>(
    'localeSlugMap',
    () => ({})
  );

  const pageVisibility = useState<string>('contentPageVisibility');

  return {
    provide: {
      colorMode,
      localeSlugMap,
      pageVisibility
    }
  };
});
